<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer" class="modal absolute block w-5/12 bg-white shadow-md rounded-lg"
        :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
        }">
        <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
          <h5 class="text-white text-center font-bold text-xl">Filter Table</h5>
        </div>
        <div id="modal-body" class="p-5">
          <InputText v-model="filterCapacity" id="filter-capacity" label="Kapasitas" input_class="w-full" type="number"/>
          <SelectOptions
            v-model="selectedStatus"
            label="Status"
            id="filter-status"
            :options="allStatuses"
            placeholder="Pilih status"
          />
        </div>
        <div class="modal-footer p-5">
          <div class="flex justify-center">
            <SubmitButton id="close" button_name="Close" button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal"/>
            <SubmitButton id="submit" button_name="Filter" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"/>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';
import SelectOptions from '@/components/form/SelectOptions.vue';

export default {
  name: "ModalFilterTable",
  props: {
    filter: {
      type: Object,
      default: null,
    }
  },
  components: {
    InputText, SubmitButton, SelectOptions
  },
  data() {
    return {
      showModal: true,
      selectedStatus: '',
      allStatuses: [
        { id: 'available', name: 'Available' },
        { id: 'occupied', name: 'Occupied' },
        { id: 'unavailable', name: 'Unavailable' }
      ],
      filterCapacity: ''
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200); 
    },
  }
}
</script>